export default __webpack_public_path__ + "static/media/about_image.01a5e438.jpg";